import { SubProductAction } from "features/product/types/actions.subproduct";
import { ModalName } from "features/product/types/modals";
import React from "react";
import { Draggable } from "react-beautiful-dnd";
import { BiBox, BiShow, BiHide, BiGridVertical, BiTrash } from "react-icons/bi";
import { useDispatch, useSelector } from "services/redux/rootReducer";
import useCurrentTableState from "../hooks/useCurrentTableState";
import TableCellInput from "../inputs/tableCellInput";
import { SubProductEditMode } from "../modals/subProductEditModal";
import {
    StyledCell,
    StyledDragHandleCell,
    StyledRow,
    StyledSubProductSelectorCell,
    ToggleVisibilityCell,
    TrashIconCell,
} from "./row.styled";

const TableRow: React.FC<{ id: string; idx: number }> = ({ id, idx }) => {
    const { readOnlyMode } = useSelector((state) => state.subProducts);
    const dispatch = useDispatch();

    const { columns, subProducts } = useCurrentTableState();

    const isHidden = subProducts[id].isHidden;

    const handleDelete = () => {
        if (
            !window.confirm("Are you sure you want to delete this sub-product?")
        )
            return;
        dispatch({
            type: SubProductAction.REMOVE_SUBPRODUCT,
            id,
            idx,
        });
    };

    const handleToggleRowShown = () => {
        dispatch({
            type: SubProductAction.TOGGLE_ROW_SHOWN,
            subProductId: id,
        });
    };

    const displayedCells = columns.map(({ accessor, isHidden }, idx) => (
        <StyledCell key={accessor} isHidden={isHidden}>
            <TableCellInput
                subProductId={id}
                propertyAccessor={accessor}
                columnIdx={idx}
            />
        </StyledCell>
    ));

    return (
        <Draggable
            isDragDisabled={readOnlyMode}
            key={id}
            draggableId={id}
            index={idx}
        >
            {(provided) => (
                <StyledRow ref={provided.innerRef} {...provided.draggableProps}>
                    {!readOnlyMode && (
                        <>
                            <StyledDragHandleCell {...provided.dragHandleProps}>
                                <BiGridVertical />
                            </StyledDragHandleCell>
                            <TrashIconCell onClick={handleDelete}>
                                <BiTrash />
                            </TrashIconCell>
                            <ToggleVisibilityCell
                                onClick={handleToggleRowShown}
                                isHidden={isHidden}
                            >
                                {isHidden ? <BiHide /> : <BiShow />}
                            </ToggleVisibilityCell>
                        </>
                    )}

                    <StyledSubProductSelectorCell
                        onClick={() =>
                            dispatch({
                                type: SubProductAction.OPEN_MODAL,
                                modal: {
                                    id: ModalName.SubProductModal,
                                    params: {
                                        mode: SubProductEditMode.Edit,
                                        idx,
                                    },
                                },
                            })
                        }
                    >
                        <BiBox />
                    </StyledSubProductSelectorCell>
                    {displayedCells}
                </StyledRow>
            )}
        </Draggable>
    );
};

export default TableRow;
